// store/highlightSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Attention state for the Norms export flow — drives the colored mark on the
// History button so the user knows there's something to check:
//   pending → generating (amber)   ready → done (green)   failed → error (red)
export type ExportStatus = "idle" | "pending" | "ready" | "failed";

const highlightSlice = createSlice({
  name: "highlight",
  initialState: {
    downloadHighlighted: false,
    uploadHighlighted: false,
    exportStatus: "idle" as ExportStatus,
  },
  reducers: {
    setHighlight: (state, action) => {
      state.downloadHighlighted = action.payload;
    },
    setUploadHighlight: (state, action) => {
      state.uploadHighlighted = action.payload;
    },
    // Latest-outcome wins; cleared to 'idle' when the user views the Exports
    // tab. 'ready'/'failed' never downgrade back to 'pending'.
    setExportStatus: (state, action: PayloadAction<ExportStatus>) => {
      state.exportStatus = action.payload;
    },
  },
});

export const { setHighlight, setUploadHighlight, setExportStatus } =
  highlightSlice.actions;

export default highlightSlice.reducer;
